// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import SelectOption from "./SelectOption";
import PrimaryButton from "./PrimaryButton";

const AddNewMemberToWorkspaceModal = () => {
  return (
    <>
      <p className="text-[#9392A2] mt-2 text-sm font-medium leading-snug tracking-tight">Enter users email so person can <br />join your workspace.</p>
      <InputField label="Team member email" className="mt-4 mb-2" />
      <SelectOption label="Role" options={["Editor", "Viewer"]} />
      <PrimaryButton label="Proceed" className="w-full py-2 rounded-3xl mt-5" />
    </>
  );
};

export default AddNewMemberToWorkspaceModal;